/* eslint-disable no-unused-vars */
import { StatsState } from './modules/statspro/types';
import { MatchCentreState } from './modules/match-centre/types';
import { BrownlowTrackerState } from './modules/brownlow-tracker/types';
import { DraftTrackerState } from './modules/draft-tracker/types';

/**
 * @typedef {object} ReduxState
 * @property {{[key: string]: object, list: object[]}} competitions
 * @property {{[key: string]: object, list: object[]}} seasons
 * @property {{[key: string]: object, list: object[]}} rounds
 * @property {MatchCentreState} matchCentre
 * @property {StatsState} statspro
 * @property {BrownlowTrackerState} brownlowTracker
 * @property {DraftTrackerState} draftTracker
 */

/**
 * @typedef {( any ) => Action} ActionCreator
 */

/**
 * @typedef {object} SignalActionObject
 * @property {string} REQUEST
 * @property {string} SUCCESS
 * @property {string} FAILURE
 * @property {ActionCreator} request
 * @property {ActionCreator} success
 * @property {ActionCreator} failure
 */

/**
 * @typedef {object} Action
 * @property {string} type
 * @property {any} payload
 */
